import { render, staticRenderFns } from "./OrgLayout.vue?vue&type=template&id=35c06d5d"
import script from "./OrgLayout.vue?vue&type=script&lang=js"
export * from "./OrgLayout.vue?vue&type=script&lang=js"
import style0 from "./OrgLayout.vue?vue&type=style&index=0&id=35c06d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports